import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

import {
  Department,
  Event,
  EventAccessibilityMode,
  EventActivityType,
  EventDateRange,
  // EventTarget,
} from '../../types/fam-graphql'
import type { RootState } from '../store'

import { actionTypes } from './types'

export const name = 'eventLanding'

export type EventLandingState = {
  list: Event[] | null
  departments: Department[]
  eventAccessibilityModes: EventAccessibilityMode[]
  eventActivityTypes: EventActivityType[]
  // eventTargets: EventTarget[]
  eventDates: EventDateRange[]
  page: number
  filters: any
  hasMorePages: boolean
}

//
// Initial state
//
const initialState: EventLandingState = {
  list: null,
  departments: [],
  eventAccessibilityModes: [],
  eventActivityTypes: [],
  // eventTargets: [],
  eventDates: [],
  page: 1,
  filters: null,
  hasMorePages: false,
}

//
// Slice (Actions & Reducers)
//
const slice = createSlice({
  name,
  initialState,
  reducers: {
    init: () => undefined,
    setEvents: (state, action: actionTypes.setEvents) => {
      state.list = action.payload
    },
    setHasMorePages: (state, action: actionTypes.setHasMorePages) => {
      state.hasMorePages = action.payload
    },
    setEventsPage: (state, action: actionTypes.setEventsPage) => {
      state.page = action.payload
    },
    setEventsFilters: (state, action: actionTypes.setEventsFilters) => {
      state.filters = action.payload
    },
    appendEvents: (state, action: actionTypes.appendEvents) => {
      state.list = [...(state?.list ?? []), ...action.payload]
    },
    loadEvents: () => undefined,
    loadMoreEventsPage: () => undefined,
    setDepartments: (state, action: actionTypes.setDepartments) => {
      state.departments = action.payload
    },
    setEventAccessibilityModes: (
      state,
      action: actionTypes.setEventAccessibilityModes
    ) => {
      state.eventAccessibilityModes = action.payload
    },
    setEventActivityTypes: (
      state,
      action: actionTypes.setEventActivityTypes
    ) => {
      state.eventActivityTypes = action.payload
    },
    // setEventTargets: (state, action: actionTypes.setEventTargets) => {
    //   state.eventTargets = action.payload
    // },
    setEventDates: (state, action: actionTypes.setEventDates) => {
      state.eventDates = action.payload
    },
  },
  extraReducers: {
    [HYDRATE]: (_state, action) => {
      return action.payload[name]
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//
// const root = (state: RootState) => state.eventLanding

const root = (state: RootState) => state[name]
const list = (state: RootState) => root(state).list
const page = (state: RootState) => root(state).page
const hasMorePages = (state: RootState) => root(state).hasMorePages
const departments = (state: RootState) => root(state).departments
const eventAccessibilityModes = (state: RootState) =>
  root(state).eventAccessibilityModes
const eventActivityTypes = (state: RootState) => root(state).eventActivityTypes
// const eventTargets = (state: RootState) => root(state).eventTargets
const eventDates = (state: RootState) => root(state).eventDates
const filters = (state: RootState) => root(state).filters
const apiFilters = (state: RootState) => {
  const guiFilters = root(state)?.filters
  return guiFilters
}

export const selectors = {
  list,
  page,
  filters,
  apiFilters,
  hasMorePages,
  departments,
  eventAccessibilityModes,
  eventActivityTypes,
  // eventTargets,
  eventDates,
}
